type EmptyStateProps = {
	message: string;
};

const EmptyList = ({ message }: EmptyStateProps) => {
	return (
		<div className={`text-center font-bold text-lg text-secondary-black`}>
			{message}
		</div>
	);
};

export default EmptyList;
